import { Fragment, useMemo } from "react";
import { useCampaign } from "./data";
import { useShowAds } from "@/hooks/useAds";
import { CampaignItem } from "./campaign-item";
import clsx from "clsx";
import { AdsSliderBitmedia } from "../ads/ads-bitslider";
import Spinner from "../spinner";

export function Campaign(props: { tab: string }) {
  const { tab } = props;
  const { data, isLoading } = useCampaign();
  const showBanner = useShowAds();

  const formattedData = useMemo(() => {
    if (!data?.data) {
      return [];
    }

    return data.data.filter((item) => {
      if (tab === "end") {
        return item.status === "end";
      }

      if (tab === "active") {
        return item.status === "active" || item.status === "upcoming";
      }

      return false;
    });
  }, [tab, data?.data]);

  return (
    <div
      className={clsx(
        "flex flex-col gap-4 p-4 overflow-auto h-[calc(100vh-96px)] no-scrollbar",
        {
          "!pb-32": tab === "active" && showBanner,
        }
      )}
    >
      <div className="flex flex-col  gap-4 ">
        {formattedData.map((e, index) => {
          return (
            <Fragment key={`campaign-${e.campaignCode}view`}>
              <CampaignItem item={e} key={`campaign-${e.campaignCode}`} />
              {index == 0 && tab === "end" && showBanner ? (
                <div className="w-full h-[100px] overflow-hidden rounded-lg">
                  <AdsSliderBitmedia />
                </div>
              ) : null}
            </Fragment>
          );
        })}
      </div>
      {isLoading ? <Spinner /> : null}

      {tab === "active" && showBanner ? (
        <div className="w-full h-[100px] overflow-hidden fixed left-0 bottom-0 right-0 z-[999999999]">
          <AdsSliderBitmedia />
        </div>
      ) : null}
    </div>
  );
}
